<template>
    <main class="rma-history-page">
        <v-container class="rma-history-page__container">
            <account-settings-header
                :items="links"
                title="RMA history"
                subtitle="Track repairs, review service updates, and find your return details."
                :icon="mdiWrenchOutline"
            />
            <rma-history-table id="rma-history-table" />
        </v-container>
    </main>
</template>
<script>
import Vue from 'vue'
import { mdiWrenchOutline } from '@mdi/js'
import { navLinks } from '../navigation.js'
import RmaHistoryTable from './rma_history_table'
import AccountSettingsHeader from '../account_settings_header.vue'
export default Vue.extend({
    name: `RmaHistory`,
    components: {
        RmaHistoryTable,
        AccountSettingsHeader
    },

    metaInfo: { title: `Your Account`, subTitle: `Rma History` },

    data() {
        return {
            links: navLinks,
            mdiWrenchOutline
        }
    }
})
</script>

<style scoped>
.rma-history-page {
    position: relative;
    isolation: isolate;
    min-height: 100vh;
    padding: 34px 0 54px;
    color: #f2f4fa;
    background: radial-gradient(ellipse at 88% 0, rgba(219, 81, 32, 0.15), transparent 38rem),
        linear-gradient(145deg, #292c35, #22252d 65%, #2a2d35);
    font-family: 'Work Sans', 'Roboto', sans-serif;
}
.rma-history-page::before {
    position: fixed;
    z-index: 0;
    inset: 0;
    background-image: url('https://storage.googleapis.com/gusa-assets/army-BG3.png');
    background-position: center;
    background-size: cover;
    content: '';
    filter: grayscale(1) brightness(0.8);
    mix-blend-mode: soft-light;
    opacity: 0.1;
    pointer-events: none;
}
.rma-history-page__container {
    position: relative;
    z-index: 1;
    max-width: 1260px;
}
@media (max-width: 600px) {
    .rma-history-page {
        padding-top: 20px;
    }
}
</style>
